import { useResource } from '@atlassian/eoc-rrr-helpers';
import {
	createActionsHook,
	createContainer,
	createDefaultEocWrapper,
	createHook,
	createStore,
	createSubscriber,
} from '@atlassian/eoc-rss-helpers';

import { type ScheduleEntity } from '../../services/endpoints/list/types';
import { getSchedulesResource } from '../../services/resources';
import { getSafe } from '../../utils/validators';

import { actions } from './actions';
import { initialState } from './state';
import { type ContainerProps } from './types';

const store = createStore<typeof initialState, typeof actions>({
	initialState,
	actions,
});

const Container = createContainer<typeof initialState, typeof actions>(store, {
	Wrapper: createDefaultEocWrapper({
		useSyncContainerProps: (): ContainerProps => {
			const { data: schedulesResponse } = useResource(getSchedulesResource);

			const schedules = getSafe(() => schedulesResponse!.schedules, [] as ScheduleEntity[]);

			return { schedules };
		},
	}),
});

// REFACTOR: We can create many different subscriber with selectors to avoid unnecessary rerenders
// See: https://atlassian.github.io/react-sweet-state/#/api/subscriber?id=example
const Subscriber = createSubscriber<typeof initialState, typeof actions>(store);

const useStore = createHook<typeof initialState, typeof actions>(store);

const useActions = createActionsHook<typeof initialState, typeof actions>(store);

export { Container, Subscriber, useStore, store, useActions };
